import { Action, SET_SEARCH_TERMS, TOGGLE_OPEN_STATE } from './types'

export interface GlobalSearchReducerState {
  searchTerms: string
  isOpen: boolean
}

export const initialState = {
  searchTerms: '',
  isOpen: false,
}

export default function globalSearchReducer(state = initialState, action: Action): GlobalSearchReducerState {
  switch (action.type) {
    case SET_SEARCH_TERMS:
      return {
        ...state,
        searchTerms: action.payload,
      }
    case TOGGLE_OPEN_STATE:
      return {
        ...state,
        isOpen: action.payload,
      }
    default:
      return state
  }
}
